import { Component, OnInit } from '@angular/core';
import { UiService } from '../../../../services/ui.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {
  public errors: ErrorModalMessage[] = [];
  public error: ErrorModalMessage;
  public errorTitle: string = "An Error Has Occurred.";
  constructor(private uiService: UiService) { }

  ngOnInit(): void {
    this.errors = this.uiService.getModalData()?.errors;
    // this.error = this.uiService.getModalData()?.error;
    // if(this.error)
    //   this.errorTitle = this.error.errorTitle;
  }

  okOnClick() {
    this.uiService.modalInstances.pop();
  }

}

export class ErrorModalMessage 
{
  errorMessage: string;
  errorTitle: string;

  constructor(message?: string, title?: string) {    
    if(!title)
      this.errorTitle = 'An Error Has Occurred';
    else if(title)
      this.errorTitle = title;
    if(!message)
      this.errorTitle = 'An Error Has Occurred.';
    else if(message)
      this.errorMessage = message;
  }
}